// IM-XPR-002 (IM-UX-114) — Retorno explícito ao objetivo. Quando o fluxo precisa de uma tela especializada, o link
// guarda de onde a pessoa veio (só nesta aba do navegador); a tela especializada mostra "Voltar ao objetivo". Visitar uma
// área principal esquece o retorno. Armazenamento indisponível = sem barra de retorno (nada quebra).
import { useEffect, useState, type ReactNode } from 'react';
import { Link, useLocation } from 'react-router-dom';

const KEY = 'intelimove.xp.return';
interface ReturnTo { to: string; label: string }

export function rememberReturn(r: ReturnTo) { try { sessionStorage.setItem(KEY, JSON.stringify(r)); } catch { /* sem armazenamento: sem retorno */ } }
function readReturn(): ReturnTo | null {
  try { const x = JSON.parse(sessionStorage.getItem(KEY) ?? 'null'); return x && typeof x.to === 'string' && x.to.startsWith('/') && typeof x.label === 'string' ? x : null; } catch { return null; }
}
function clearReturn() { try { sessionStorage.removeItem(KEY); } catch { /* idem */ } }

/** Áreas principais da nova experiência: nelas a barra não aparece e o retorno guardado é esquecido. */
export const isMainArea = (path: string) => path === '/' || path.startsWith('/objetivos') || path === '/acompanhar' || path === '/analises';

/** Link para uma tela especializada que lembra o caminho de volta. */
export function ContextLink({ to, back, children, className = 'small-action', ...rest }: { to: string; back: ReturnTo; children: ReactNode; className?: string; 'aria-label'?: string }) {
  return <Link to={to} className={className} onClick={() => rememberReturn(back)} {...rest}>{children}</Link>;
}

export function ReturnBar() {
  const { pathname } = useLocation();
  const [r, setR] = useState<ReturnTo | null>(null);
  useEffect(() => {
    if (isMainArea(pathname)) { clearReturn(); setR(null); return; }
    setR(readReturn());
  }, [pathname]);
  if (!r) return null;
  return (
    <nav className="xp-return" aria-label="Retorno ao objetivo">
      <Link to={r.to} onClick={clearReturn}>← Voltar ao objetivo: {r.label}</Link>
      <button type="button" className="link-btn" onClick={() => { clearReturn(); setR(null); }} aria-label="Dispensar o retorno ao objetivo">Dispensar</button>
    </nav>
  );
}
